export const MODALS = {
  EDIT_SERVICE: 'EDIT_SERVICE',
  EDIT_RATES: 'EDIT_RATES',
  EDIT_DESCRIPTION: 'EDIT_DESCRIPTION',
  CHANGE_STATUS: 'CHANGE_STATUS',
  RESET_CUSTOM_RATES: 'RESET_CUSTOM_RATES',
  RESET_CUSTOM_RATES_ALL: 'RESET_CUSTOM_RATES_ALL',
  DUPLICATE: 'DUPLICATE',
  DELETE: 'DELETE',
  DELETE_CATEGORY: 'DELETE_CATEGORY',
  DELETE_ALL: 'DELETE_ALL',
  ENABLE_ALL: 'ENABLE_ALL',
  DISABLE_ALL: 'DISABLE_ALL',
  ASSIGN_CATEGORY: 'ASSIGN_CATEGORY',
  ASSIGN_CATEGORY_CONFIRM: 'ASSIGN_CATEGORY_CONFIRM',
  UPDATE_CURRENCY_CONVERSION_RATE: 'UPDATE_CURRENCY_CONVERSION_RATE',
  EDIT_CATEGORY: 'EDIT_CATEGORY',
  CHANGE_CATEGORY_VISIBILITY: 'CHANGE_CATEGORY_VISIBILITY',
  IMPORT_SERVICES: 'IMPORT_SERVICES',
  CHANGE_SERVICE_STATUS: 'CHANGE_SERVICE_STATUS',
  CHANGE_DRIP_FEED_ALL: 'CHANGE_DRIP_FEED_ALL',
};

export const ACTION = {
  SORT_POSITION_LOW_TO_HIGH: 'SORT_POSITION_LOW_TO_HIGH',
  SORT_POSITION_HIGH_TO_LOW: 'SORT_POSITION_HIGH_TO_LOW',
};

export const SEARCH_OPTIONS = [
  {
    name: 'All',
    value: 'all',
    strict: false,
  },
  {
    name: 'Service name',
    value: 'service-name',
    strict: false,
  },
  {
    name: 'Service ID',
    value: 'service-id',
    strict: true,
  },
  {
    name: 'External ID',
    value: 'external-id',
    strict: true,
  },
  {
    name: 'Category name',
    value: 'category-name',
    strict: false,
  },
]
